import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import file from "../../../../assets/svg/File.svg";
import category from "../../../../assets/svg/category.svg";
import role from "../../../../assets/svg/role.svg";
import note from "../../../../assets/svg/note.svg";
import moment from "moment";
import $ from "jquery";
import "react-datepicker/dist/react-datepicker.css";
import "date-fns";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import Select from "react-select";
import Icon from "@material-ui/core/Icon";
import DateFnsUtils from "@date-io/date-fns";
import dateIcon from "../../../../assets/svg/calendar-inside.svg";
import renewIcon from "../../../../assets/svg/ButtonRenewIcon.svg";
import calender from "../../../../assets/svg/calender.svg";
import infoBlack from "../../../../assets/svg/infoBlack.svg";
import { archiveTrigger, rightBarClose } from "../../../../redux/action/Action";
import versionBlack from "../../../../assets/svg/versionBlack.svg";
import {
  GET_DOCUMENT_BY_ID,
  GET_ALL_USERS,
  GET_VERSION_LOG,
  POST_RENEW_DOCUMENT,
  GET_DOCUMENTFORMAT,
} from "../../../../helpers/endpointService";
import axios from "axios";
import Autocomplete from "react-autocomplete";
import Moment from "moment";
import { PulseLoader } from "react-spinners";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { logoutFunction } from "../../../custom/commonFunction";

var days = 1;

var SelectedValue1 = false;

export default function Revise({ rightbarOpen, rightbarId }) {
  const userId = localStorage.getItem("UserId");
  const dispatch = useDispatch();
  const userRole = localStorage.getItem("Role");
  const [docVersion, setDocVersion] = useState();
  const [isPropertyLoader, setPropertyLoader] = useState(true);
  const [isPropertyFailed, setPropertyFailed] = useState(false);

  const [users, setUsers] = useState([]);
  const [UserArrayList, setUserArrayList] = useState([]);
  const [AdminArrayList, setAdminArrayList] = useState([]);
  const [AuthorArrayList, setAuthorArrayList] = useState([]);
  const [Approver1ArrayList, setApprover1ArrayList] = useState([]);
  const [Approver2ArrayList, setApprover2ArrayList] = useState([]);
  const [Checker1ArrayList, setChecker1ArrayList] = useState([]);
  const [Checker2ArrayList, setChecker2ArrayList] = useState([]);
  const [Consultant1ArrayList, setConsultant1ArrayList] = useState([]);
  const [Consultant2ArrayList, setConsultant2ArrayList] = useState([]);
  const [openAuthorList, setOpenAuthorList] = useState(false);
  const [openChecker1List, setOpenChecker1List] = useState(false);
  const [openChecker2List, setOpenChecker2List] = useState(false);
  const [openConsultant1List, setOpenConsultant1List] = useState(false);
  const [openConsultant2List, setOpenConsultant2List] = useState(false);
  const [openApprover1List, setOpenApprover1List] = useState(false);
  const [openApprover2List, setOpenApprover2List] = useState(false);
  const [approver1Error, setApprover1Error] = useState(false);
  const [approver2Error, setApprover2Error] = useState(false);
  const [checker1Error, setChecker1Error] = useState(false);
  const [checker2Error, setChecker2Error] = useState(false);
  const [consultant1Error, setConsultant1Error] = useState(false);
  const [consultant2Error, setConsultant2Error] = useState(false);
  const [authorError, setAuthorError] = useState(false);
  const [valueChanged, setValueChanged] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [sumbitOne, setSubmitOne] = useState(true);
  const [newDocNumber, setNewDocNumber] = useState("");
  const [isSmallMobile, setisSmallMobile] = useState(false);
  const [isMobile, setisMobile] = useState(false);

  const [inputData, setInputData] = useState({
    id: 0,
    category1Name: "",
    category2Name: "",
    category1Id: 0,
    category2Id: 0,
    version: "",
    revisedDocumentId: 0,
    revisedDocumentNo: "",
    documentNo: "",
    documentName: "",
    documentNumber: "",
    author: "",
    authorId: 0,
    checker1: "",
    checker1Id: 0,
    checker2Id: 0,
    checker2: "",
    consultant1: "",
    consultant1Id: 0,
    consultant2: "",
    consultant2Id: 0,
    approver1: "",
    approver1Id: 0,
    approver2: "",
    approver2Id: 0,
    expiryDate: "",
    note: "",
  });

  const close = () => {
    dispatch(rightBarClose());
    $("body").removeClass("scrollhide");
  };
  const renderUserTitle = (state, val) => {
    return state?.userName?.toLowerCase()?.indexOf(val?.toLowerCase()) !== -1;
  };

  useEffect(() => {
    const intervals = setInterval(() => {
      resize();
    }, 10);
    setPropertyLoader(true);
    setPropertyFailed(false);
    if (rightbarOpen) {
      $("body").addClass("scrollhide");
    }
    const fetchData = async () => {
      let propApiUrl = `${GET_DOCUMENT_BY_ID}?docId=${rightbarId}`;
      await axios
        .get(propApiUrl)
        .then((response) => {
          if (response?.status === 200) {
            fetchFormat(
              response.data.category1Id,
              response.data.category2Id,
              response.data.documentNumber
            );
            fetchVersion();
            fetchReviewers();
            fetchAdminUsers();
            setInputData({
              id: response.data.id,
              version: response.data.version,
              revisedDocumentId: response.data.revisedDocumentId,
              documentName: response.data.documentName,
              documentNo: response.data.documentNo,
              documentNumber: response.data.documentNumber,
              note: "",
              expiryDate: "",
              author: response.data.authorName
                ? {
                    label: response.data.authorName,
                    value: response.data.adminAuthorId
                      ? response.data.adminAuthorId
                      : 0,
                  }
                : "",
              authorId: response.data.adminAuthorId
                ? response.data.adminAuthorId
                : 0,
              checker1: response.data.checker1Name
                ? {
                    label: response.data.checker1Name,
                    value: response.data.adminChecker1Id
                      ? response.data.adminChecker1Id
                      : 0,
                  }
                : "",
              checker1Id: response.data.adminChecker1Id
                ? response.data.adminChecker1Id
                : 0,
              checker2: response.data.checker2Name
                ? {
                    label: response.data.checker2Name,
                    value: response.data.adminChecker2Id
                      ? response.data.adminChecker2Id
                      : 0,
                  }
                : "",
              checker2Id: response.data.adminChecker2Id
                ? response.data.adminChecker2Id
                : 0,
              consultant1: response.data.consultant1Name
                ? {
                    label: response.data.consultant1Name,
                    value: response.data.adminConsultant1Id
                      ? response.data.adminConsultant1Id
                      : 0,
                  }
                : "",
              consultant1Id: response.data.adminConsultant1Id
                ? response.data.adminConsultant1Id
                : 0,
              consultant2: response.data.consultant2Name
                ? {
                    label: response.data.consultant2Name,
                    value: response.data.adminConsultant2Id
                      ? response.data.adminConsultant2Id
                      : 0,
                  }
                : "",
              consultant2Id: response.data.adminConsultant2Id
                ? response.data.adminConsultant2Id
                : 0,
              approver1: response.data.approver1Name
                ? {
                    label: response.data.approver1Name,
                    value: response.data.adminApprover1Id
                      ? response.data.adminApprover1Id
                      : 0,
                  }
                : "",
              approver1Id: response.data.adminApprover1Id
                ? response.data.adminApprover1Id
                : 0,
              approver2: response.data.approver2Name
                ? {
                    label: response.data.approver2Name,
                    value: response.data.adminApprover2Id
                      ? response.data.adminApprover2Id
                      : 0,
                  }
                : "",
              approver2Id: response.data.adminApprover2Id
                ? response.data.adminApprover2Id
                : 0,
              category1Name: response.data.category1Name,
              category2Name: response.data.category2Name,
              category1Id: response.data.category1Id,
              category2Id: response.data.category2Id,
            });
          }
        })
        .catch((err) => {
          setPropertyLoader(false);
          setPropertyFailed(true);
          logoutFunction(err?.response?.status);
        });
    };
    fetchData();

    const fetchFormat = async (category1Id, category2Id, docNo) => {
      let docData = {
        id: 0,
        category1Name: "",
        category2Name: "",
        category1Id: category1Id,
        category2Id: category2Id,
        documentId: 0,
        documentFormat: "",
        numberFormat: "",
        versionFormat: "",
        versionNumber: 0,
      };
      let versionApiUrl = `${GET_DOCUMENTFORMAT}?docId=${rightbarId}`;
      await axios
        .post(versionApiUrl, docData)
        .then((response) => {
          setPropertyLoader(false);
          if (response?.status === 200) {
            setNewDocNumber(
              response.data?.documentFormat +
                docNo +
                " " +
                response.data?.versionFormat +
                " " +
                response.data?.versionNumber
            );
          }
        })
        .catch((err) => {
          setPropertyLoader(false);

          logoutFunction(err?.response?.status);
        });
    };

    ////////////////// Fetch Doc version ///////////////////////
    const fetchVersion = async () => {
      let versionApiUrl = `${GET_VERSION_LOG}?docId=${rightbarId}`;
      await axios
        .get(versionApiUrl)
        .then((response) => {
          if (response?.status === 200) {
            setDocVersion(response.data);
          }
        })
        .catch((err) => {
          logoutFunction(err?.response?.status);
        });
    };

    ////////////////// Fetch Reviewers ///////////////////////

    const fetchReviewers = async () => {
      let reviewerApiUrl = `${GET_ALL_USERS}`;
      await axios
        .get(reviewerApiUrl)
        .then((response) => {
          if (response?.status === 200) {
            // console.log(response.data)
            setUsers(response.data);
          }
        })
        .catch((err) => {
          logoutFunction(err?.response?.status);
        });
    };

    const fetchAdminUsers = async () => {
      let reviewerApiUrl = `${GET_ALL_USERS}?includeAdmin=true`;
      await axios
        .get(reviewerApiUrl)
        .then((response) => {
          if (response?.status === 200) {
            setAdminArrayList(
              response.data?.map((res) => {
                return {
                  value: res.id,
                  label: res.userName,
                };
              })
            );
          }
        })
        .catch((err) => {
          logoutFunction(err?.response?.status);
        });
    };
  }, [rightbarId]);

  const resize = () => {
    if (window.innerWidth < 300) {
      setisSmallMobile(true);
    } else {
      setisSmallMobile(false);
    }
    if (window.innerWidth < 850) {
      setisMobile(true);
    } else {
      setisMobile(false);
    }
  };

  /////////////////////////////////////////// Submit document /////////////////////////////////
  const SubmitDocumentValidate = () => {
    const inputs2 = document.querySelectorAll(".renew-document-autocomplete");
    const isValid2 = Array.from(inputs2).every((input) => input.value !== "");

    const authorEmpty = !inputData.author || inputData.author === null;
    const checker1Empty = !inputData.checker1 || inputData.checker1 === null;
    const approver1Empty = !inputData.approver1 || inputData.approver1 === null;

    setAuthorError(authorEmpty);
    setChecker1Error(checker1Empty);
    setApprover1Error(approver1Empty);

    if (isValid2 && !authorEmpty && !checker1Empty && !approver1Empty) {
      submitRenewDocument();
    } else {
      const emptyInputs2 = Array.from(inputs2).filter(
        (input) => input.value === ""
      );
      if (emptyInputs2.length > 0) {
        emptyInputs2.forEach((input) => {
          input.style.borderColor = "red";
          input.addEventListener("input", () => {
            if (input.value !== "") {
              input.style.borderColor = "";
            }
          });
        });
      }
    }
  };

  const submitRenewDocument = () => {
    if (sumbitOne === true) {
      setSubmitOne(false);
      let myDateUTC;
      if (inputData.expiryDate) {
        let current = new Date();
        let h = current.getHours();
        let m = current.getMinutes();
        let s = current.getSeconds();
        let formattedTime = `${h.toString().padStart(2, "0")}:${m
          .toString()
          .padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
        let Newdate = moment(inputData.expiryDate).format("YYYY-MM-DD");
        var dataDate = Newdate + " " + formattedTime;
        myDateUTC = new Date(dataDate).toISOString();
        /*  let myDate = inputData.expiryDate + "T" + formattedTime;
                    myDateUTC = new Date(myDate).toISOString(); */
      }

      setPropertyLoader(true);

      const renewDetails = {
        id: 0,
        documentName: inputData.documentName,
        revisedDocumentId: inputData.id,
        documentNo: inputData.documentNumber,
        version: inputData.version,
        category1Name: inputData.category1Name,
        category2Name: inputData.category2Name,
        category1Id: inputData.category1Id,
        category2Id: inputData.category2Id,
        authorId: parseInt(inputData.author.value) || 0,
        authorName: inputData.author.label || null,
        checker1Id: parseInt(inputData.checker1.value) || 0,
        checker2Id: parseInt(inputData.checker2.value) || 0,
        checker1Name: inputData.checker1.label || null,
        checker2Name: inputData.checker2.label || null,
        consultant1Id: parseInt(inputData.consultant1.value) || 0,
        consultant2Id: parseInt(inputData.consultant2.value) || 0,
        consultant1Name: inputData.consultant1.label || null,
        consultant2Name: inputData.consultant2.label || null,
        approver1Id: parseInt(inputData.approver1.value) || 0,
        approver2Id: parseInt(inputData.approver2.value) || 0,
        approver1Name: inputData.approver1.label || null,
        approver2Name: inputData.approver2.label || null,
        documentDate: null,
        documentStatus: "",
        approvalStatus: "",
        reviewDate: myDateUTC || null,
        remarks: inputData.note || null,
        reason: inputData.note,
        isResubmission: false,
      };

      axios({
        method: "POST",
        url: `${POST_RENEW_DOCUMENT}?userId=${userId}`,
        data: renewDetails,
      })
        .then((response) => {
          setPropertyLoader(false);
          if (response?.status === 200) {
            if (response.data == "document is not published") {
              toast.warning("Document is not published", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: "colored",
              });

              dispatch(rightBarClose());
            } else if (response.data == "success") {
              toast.success("Renewed successfully", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: "colored",
              });

              dispatch(rightBarClose());
              dispatch(archiveTrigger());
              $("body").removeClass("scrollhide");
            }
          }
        })
        .catch((err) => {
          toast.error("Renew failed", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "colored",
          });
          setSubmitOne(true);
          dispatch(rightBarClose());
          setPropertyLoader(false);

          logoutFunction(err?.response?.status);
        });
    }
  };

  useEffect(() => {
    let usersOption = users?.map((user) => {
      return {
        value: user.id,
        label: user.userName,
      };
    });
    setUserArrayList(usersOption);
    setApprover1ArrayList(usersOption);
    setApprover2ArrayList(usersOption);
    setChecker1ArrayList(usersOption);
    setChecker2ArrayList(usersOption);
    setConsultant1ArrayList(usersOption);
    setConsultant2ArrayList(usersOption);
  }, [users]);

  useEffect(() => {
    setAuthorArrayList(AdminArrayList);
  }, [AdminArrayList]);

  useEffect(() => {
    GetDropdownList();
  }, [valueChanged]);

  const handleSelectChange = (value, field) => {
    SelectedValue1 = true;
    setInputData((prevData) => ({
      ...prevData,
      [field]: value,
    }));

    setValueChanged(!valueChanged);
  };

  const GetDropdownList = () => {
    const {
      author,
      approver1,
      approver2,
      checker1,
      checker2,
      consultant1,
      consultant2,
    } = inputData;

    const Array1 = UserArrayList;
    const Array2 = AdminArrayList;
    const SelectedValues = [];
    const AuthorValue = [];
    const Checker1Value = [];
    const Checker2Value = [];
    const Consultant1Value = [];
    const Consultant2Value = [];
    const Approver1Value = [];
    const Approver2Value = [];
    let FilterArray = UserArrayList;
    let NewFilterArray = AdminArrayList;
    const ArrayResult = [
      author,
      approver1,
      approver2,
      checker1,
      checker2,
      consultant1,
      consultant2,
    ];

    ArrayResult.forEach((j) => {
      if (j) {
        SelectedValues.push(j.value); // Store the selected values
      }
    });

    FilterArray = FilterArray.filter(
      (item) => !SelectedValues.includes(item.value)
    );
    NewFilterArray = NewFilterArray.filter(
      (item) => !SelectedValues.includes(item.value)
    );

    AuthorValue.push(...Array2.filter((item) => item.value === author));
    Checker1Value.push(...Array1.filter((item) => item.value === checker1));
    Checker2Value.push(...Array1.filter((item) => item.value === checker2));
    Consultant1Value.push(
      ...Array1.filter((item) => item.value === consultant1)
    );
    Consultant2Value.push(
      ...Array1.filter((item) => item.value === consultant2)
    );
    Approver1Value.push(...Array1.filter((item) => item.value === approver1));
    Approver2Value.push(...Array1.filter((item) => item.value === approver2));

    const FinalAuthorResult = [...AuthorValue, ...NewFilterArray];
    const FinalApprover1Result = [...Approver1Value, ...FilterArray];
    const FinalApprover2Result = [...Approver2Value, ...FilterArray];
    const FinalChecker1Result = [...Checker1Value, ...FilterArray];
    const FinalChecker2Result = [...Checker2Value, ...FilterArray];
    const FinalConsultant1Result = [...Consultant1Value, ...FilterArray];
    const FinalConsultant2Result = [...Consultant2Value, ...FilterArray];

    setAuthorArrayList(FinalAuthorResult);
    setApprover1ArrayList(FinalApprover1Result);
    setApprover2ArrayList(FinalApprover2Result);
    setChecker1ArrayList(FinalChecker1Result);
    setChecker2ArrayList(FinalChecker2Result);
    setConsultant1ArrayList(FinalConsultant1Result);
    setConsultant2ArrayList(FinalConsultant2Result);
  };

  const handleChange = (e, field) => {
    if (field === "expiryDate") {
      const inputDate = e;
      setInputData((prevData) => ({
        ...prevData,
        ["expiryDate"]: inputDate,
      }));
    } else {
      const { name, value } = e.target;
      setInputData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  return (
    <>
      <div
        className={`viewbar ${rightbarOpen ? "viewbarOpen" : ""} ${
          isPropertyLoader ? "overFlowHidden" : ""
        }`}
      >
        {isPropertyLoader && (
          <div className="spinner_overlay-new">
            <div className="loader-new">
              <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
            </div>
          </div>
        )}

        <ToastContainer
          limit={1}
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />

        {isPropertyFailed && (
          <div className="spinner_overlay-new">
            <div className="loader-new">
              <span>Loading failed</span>
            </div>
          </div>
        )}
        <div className="viewMain">
          <div className="viewTitle">
            <span>Renew document</span>
            {!isPropertyLoader && (
              <span className="close mt-2" onClick={close}>
                ✕
              </span>
            )}
          </div>
          <>
            <div className="marginTop-13 renewInput">
              <div className="row">
                <div className="col-sm-6 col-12 d-flex flex-column mb-2 mt-2">
                  <span className="commonsearch-field">
                    <img
                      style={{ position: "relative", top: "-1px" }}
                      src={infoBlack}
                      alt=""
                    />{" "}
                    Document no.
                  </span>
                  <span
                    style={{
                      fontWeight: "400",
                      fontSize: "13px",
                      color: "#605E5C",
                    }}
                  >
                    {newDocNumber}
                  </span>
                </div>
                <div className="col-sm-6 col-12 mb-2 mt-2">
                  <div className="inputTitle commonsearch-field">
                    <img src={file} alt="" />
                    <span> Document name</span>
                  </div>
                  <span
                    className="mt-1"
                    style={{
                      fontWeight: "400",
                      fontSize: "13px",
                      color: "#605E5C",
                    }}
                  >
                    {inputData.documentName}
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6 col-12 d-flex flex-column mt-2 mb-2">
                  <span className="commonsearch-field">
                    <img
                      style={{ position: "relative", top: "-1px" }}
                      src={infoBlack}
                      alt=""
                    />{" "}
                    Revised document no.
                  </span>
                  <span
                    style={{
                      fontWeight: "400",
                      fontSize: "13px",
                      color: "#605E5C",
                    }}
                  >
                    {inputData.documentNo}
                  </span>
                </div>
                <div className="col-sm-6 col-12 mt-2 mb-2">
                  <div className="inputTitle commonsearch-field">
                    <img src={category} alt="" />
                    <span> Category 1</span>
                  </div>
                  <span
                    className="mt-1"
                    style={{
                      fontWeight: "400",
                      fontSize: "13px",
                      color: "#605E5C",
                    }}
                  >
                    {inputData.category1Name}
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6 col-12 mt-2 mb-2">
                  <div className="inputTitle commonsearch-field">
                    <img src={category} alt="" />
                    <span> Category 2</span>
                  </div>
                  <span
                    className="mt-1"
                    style={{
                      fontWeight: "400",
                      fontSize: "13px",
                      color: "#605E5C",
                    }}
                  >
                    {inputData.category2Name}
                  </span>
                </div>

                <div className={`col-sm-6 col-12 mb-2`}>
                  <div className="inputTitle mt-2 commonsearch-field">
                    <img src={role} alt="" />
                    <span>
                      {" "}
                      Author&nbsp;<span style={{ color: "#ee192d" }}>*</span>
                    </span>
                  </div>
                  <div className="mt-1">
                    <Select
                      className={`text-12-normal ${authorError ? "error" : ""}`}
                      classNamePrefix="assigngroups"
                      value={inputData.author}
                      options={AuthorArrayList}
                      defaultValue={inputData.author || "Select"}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={(e) => handleSelectChange(e, "author")}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className={`col-sm-6 col-12 mb-2`}>
                  <div className="inputTitle mt-2 commonsearch-field">
                    <img src={role} alt="" />
                    <span>
                      {" "}
                      Checker 1&nbsp;<span style={{ color: "#ee192d" }}>*</span>
                    </span>
                  </div>
                  <div className="mt-1">
                    <Select
                      className={`text-12-normal ${
                        checker1Error ? "error" : ""
                      }`}
                      classNamePrefix="assigngroups"
                      value={inputData.checker1}
                      options={Checker1ArrayList}
                      defaultValue={inputData.checker1 || "Select"}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={(e) => handleSelectChange(e, "checker1")}
                    />
                  </div>
                </div>

                <div className={`col-sm-6 col-12 mb-2`}>
                  <div className="inputTitle mt-2 commonsearch-field">
                    <img src={role} alt="" />
                    <span> Checker 2</span>
                  </div>
                  <div className="mt-1">
                    <Select
                      className="text-12-normal"
                      classNamePrefix="assigngroups"
                      value={inputData.checker2}
                      options={Checker2ArrayList}
                      defaultValue={inputData.checker2 || "Select"}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={(e) => handleSelectChange(e, "checker2")}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className={`col-sm-6 col-12 mb-2`}>
                  <div className="inputTitle mt-2 commonsearch-field">
                    <img src={role} alt="" />
                    <span> Consultant 1</span>
                  </div>
                  <div className="mt-1">
                    <Select
                      className="text-12-normal"
                      classNamePrefix="assigngroups"
                      value={inputData.consultant1}
                      options={Consultant1ArrayList}
                      defaultValue={inputData.consultant1 || "Select"}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={(e) => handleSelectChange(e, "consultant1")}
                    />
                  </div>
                </div>

                <div className={`col-sm-6 col-12 mb-2`}>
                  <div className="inputTitle mt-2 commonsearch-field">
                    <img src={role} alt="" />
                    <span> Consultant 2</span>
                  </div>
                  <div className="mt-1">
                    <Select
                      className="text-12-normal"
                      classNamePrefix="assigngroups"
                      value={inputData.consultant2}
                      options={Consultant2ArrayList}
                      defaultValue={inputData.consultant2 || "Select"}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={(e) => handleSelectChange(e, "consultant2")}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className={`col-sm-6 col-12 mb-2`}>
                  <div className="inputTitle mt-2 commonsearch-field">
                    <img src={role} alt="" />
                    <span>
                      {" "}
                      Approver 1&nbsp;
                      <span style={{ color: "#ee192d" }}>*</span>
                    </span>
                  </div>
                  <div className="mt-1">
                    <Select
                      className={`text-12-normal ${
                        approver1Error ? "error" : ""
                      }`}
                      classNamePrefix="assigngroups"
                      value={inputData.approver1}
                      options={Approver1ArrayList}
                      defaultValue={inputData.approver1 || "Select"}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={(e) => handleSelectChange(e, "approver1")}
                    />
                  </div>
                </div>

                <div className={`col-sm-6 col-12 mb-2`}>
                  <div className="inputTitle mt-2 commonsearch-field">
                    <img src={role} alt="" />
                    <span> Approver 2</span>
                  </div>
                  <div className="mt-1">
                    <Select
                      className="text-12-normal"
                      classNamePrefix="assigngroups"
                      value={inputData.approver2}
                      options={Approver2ArrayList}
                      defaultValue={inputData.approver2 || "Select"}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={(e) => handleSelectChange(e, "approver2")}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6 col-12 mb-2 mt-1">
                  <div className="inputTitle date-bottom commonsearch-field">
                    <img src={calender} alt="" />
                    <span> Expiry date</span>
                  </div>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      autoOk
                      variant="inline"
                      inputVariant="outlined"
                      className="form-control date-input-class border-radius shiptype-select mt-2 f-12"
                      emptyLabel="dd-mmm-yyyy"
                      keyboardIcon={<img src={dateIcon} />}
                      minDate={new Date(
                        Date.now() + days * 24 * 60 * 60 * 1000
                      ).toString()}
                      format="dd-MMM-yyyy"
                      value={inputData.expiryDate ? inputData.expiryDate : null}
                      size="small"
                      onChange={(e) => handleChange(e, "expiryDate")}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </div>

              <div className="col-12 mt-3">
                <div className="inputTitle commonsearch-field">
                  <img src={note} alt="" />
                  <span> Note</span>
                </div>
                <textarea
                  value={inputData.note}
                  onChange={(e) => handleChange(e)}
                  name="note"
                  className="form-control border-radius shiptype-select mt-2"
                  style={{
                    width: "100%",
                    height: "70px",
                    fontSize: "12px",
                    maxHeight: "70px",
                  }}
                />
              </div>
              {hasError && (
                <div className="mt-1">
                  <span style={{ color: "red" }}>
                    Input values has duplicates
                  </span>
                </div>
              )}

              <div className="button">
                <button id="edit" onClick={SubmitDocumentValidate}>
                  <img
                    style={{
                      marginTop: "-2px",
                      marginRight: "4px",
                      width: "14px",
                    }}
                    src={renewIcon}
                    alt=""
                  />
                  Renew
                </button>
              </div>

              <div className="row">
                <div
                  className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2`}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex m-0 label-text ${
                        isMobile ? "pt-2" : ""
                      }`}
                    >
                      <img
                        alt=""
                        className="properties-img"
                        src={versionBlack}
                      />{" "}
                      <span className="pl-10 properties-span">Versions</span>
                    </label>
                    <div className="table-responsive mb-4 mt-3">
                      <table id="versionTable" style={{ width: "100%" }}>
                        <thead>
                          <tr>
                            <th
                              className={`${
                                isSmallMobile ? "Author-width" : ""
                              }`}
                            >
                              Version
                            </th>
                            <th
                              className={`${
                                isSmallMobile ? "Author-width" : ""
                              }`}
                            >
                              Author
                            </th>
                            <th
                              className={`${
                                isSmallMobile ? "Publisheddate-width" : ""
                              } no-wrap`}
                            >
                              Published date/time
                            </th>
                            <th
                              className={`${
                                isSmallMobile ? "Author-width" : ""
                              }`}
                            >
                              {" "}
                              Checker
                            </th>
                            <th
                              className={`${
                                isSmallMobile ? "Author-width" : ""
                              }`}
                            >
                              {" "}
                              Approver{" "}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {docVersion && docVersion?.length !== 0 ? (
                            docVersion?.map((i, index) => (
                              <tr id={index}>
                                <td className="no-wrap">{i.documentVersion}</td>
                                <td className="no-wrap">{i.authorName}</td>
                                <td className="no-wrap">
                                  {i.publishedDate
                                    ? Moment(
                                        new Date(Date.parse(i.publishedDate))
                                      ).format("DD-MMM-YYYY h:mm A")
                                    : ""}
                                </td>
                                <td className="no-wrap">{i.checkerName}</td>
                                <td className="no-wrap">{i.approverName}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td className="table-noversion" colSpan={5}>
                                No version history
                              </td>
                            </tr>
                          )}
                          <tr></tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        </div>
      </div>
    </>
  );
}
